import { createPreviewBodyNotExcludedSelector } from './selector-builders';

export const DYSLEXIA_FONT_STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Comic+Neue:wght@300;400;700&display=swap');

  @font-face {
    font-family: 'OpenDyslexic';
    src:
      url('https://cdn.jsdelivr.net/npm/@fontsource/opendyslexic@5.2.5/files/opendyslexic-latin-400-normal.woff2') format('woff2'),
      url('https://unpkg.com/@fontsource/opendyslexic@5.2.5/files/opendyslexic-latin-400-normal.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'OpenDyslexic';
    src:
      url('https://cdn.jsdelivr.net/npm/@fontsource/opendyslexic@5.2.5/files/opendyslexic-latin-700-normal.woff2') format('woff2'),
      url('https://unpkg.com/@fontsource/opendyslexic@5.2.5/files/opendyslexic-latin-700-normal.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
  }

  ${createPreviewBodyNotExcludedSelector()} {
    font-family: OpenDyslexic, "Comic Neue", Arial, Helvetica, sans-serif !important;
  }
`;
